import React from 'react';
import { AnimatePresence } from 'framer-motion';

import { Field, Box } from '../../index';

interface FieldErrorProps {
  error?: string;
  touched?: boolean;
  showIcon?: boolean;
  className?: string;
}

export function FieldError({
  error,
  touched = true,
  showIcon = true,
  className = '',
}: FieldErrorProps) {
  const shouldShow = error && touched;

  return (
    <AnimatePresence mode="wait">
      {shouldShow && (
        <Box
          as={Field.ErrorText}
          className={className}
          display="flex"
          alignItems="center"
          opacity={1}
          height="auto"
          transition="opacity 0.2s ease-in-out"
        >
          {showIcon && (
            <Box display="inline-block" marginRight="4px">
              <svg width="16px" height="16px" viewBox="0 0 16 16" fill="currentColor">
                <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z" />
                <path d="M7.002 11a1 1 0 112 0 1 1 0 01-2 0zM7.1 4.995a.905.905 0 111.8 0l-.35 3.507a.552.552 0 01-1.1 0L7.1 4.995z" />
              </svg>
            </Box>
          )}
          {error}
        </Box>
      )}
    </AnimatePresence>
  );
}
